import React, { FunctionComponent } from "react";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { COUPON_COLUMNS, LEAD_ROTATION_COLUMNS, PROJECT_COLUMNS } from "../../Values/tables";
import {
  fetchCoupon,
  deleteCoupon,
} from "../../Services/contacts";
import TopBar from "../../Components/TopBar/TopBar";
import commonStyle from "../common.module.css";
import Loading from "../../Components/Loading/Loading";
import CustomTable from "../../Components/CustomTable/CustomTable";
import styles from './Coupon.module.css';
import { themeColors } from "../../Components/theme";
import { useMediaQuery } from "@material-ui/core";


type props = {
  user: any;
  contacts: any;
  history: any;
  role: any;
  organizationUsers: any;
  teamLeadUsers: any;
  theme: any;
};

const CouponList: FunctionComponent<props> = ({
  user,
  contacts,
  history,
  role,
  organizationUsers,
  teamLeadUsers,
  theme
}) => {
  const dispatcher = useDispatch();
  const isMobile = useMediaQuery('(max-width: 900px)');
  const [filterData, setFilterData] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [searchedItem, setsearchedItem] = useState("");
  const [columnModal, setColumnModal] = useState(false);

  useEffect(() => {
    const unsub = fetchCoupon("QzA8Wu90bmJkLc6eYMHd", (data) =>
      setFilterData(data)
    );
    return () => {
      unsub();
    };
  }, []);

  const handleDeleteCoupon = (data: any, index: any) => {
    if (window.confirm('Are you sure you want to delete this Coupon Code?')) {
      if (index !== undefined) {
        const newList = [...filterData];
        newList.splice(index, 1);
        setFilterData(newList);
        deleteCoupon(
          "QzA8Wu90bmJkLc6eYMHd",
          newList,
          dispatcher,
        );
      }
    }
  }
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: isMobile ? "6%" : "4%", ...containerStyles }}>
        {filterData === undefined && <Loading />}
        <div className={commonStyle.topBar} style={{ marginTop: "0px", ...containerStyles }}>
          <TopBar
            history={history}
            title={"Coupon"}
            path={"/addcoupon"}
            onChange={(val) => setsearchedItem(val)}
            filterText={"Status"}
            setColumnModal={(data) => setColumnModal(data)}
            show={false}
            showStatusBox={false}
          />
        </div>
        <div className={isMobile ? commonStyle.parent : commonStyle.parentp} style={{ minHeight: "450px", ...containerStyles }}>
          <CustomTable
            tableColumns={COUPON_COLUMNS}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="Coupon"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) => setSelectedRowsData(data)}
            setSearchedItem={(val) => setsearchedItem(val)}
            handleDeleteCoupon={handleDeleteCoupon}
          />
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    theme: state.theme.isLightMode
  };
};
export default connect(mapStateToProps)(CouponList);
